import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Home, Map, Heart, Shield, TrendingUp, Users } from 'lucide-react';
export function Issues() {
  const issues = [{
    title: 'Local Control',
    description: 'Defending the right of West Valley cities to govern themselves without state overreach.',
    icon: Home
  }, {
    title: 'Smart Zoning',
    description: 'Advocating for zoning laws that protect property values and manage growth responsibly.',
    icon: Map
  }, {
    title: 'Quality of Life',
    description: 'Ensuring our communities remain premier places to live, work, and raise a family.',
    icon: Heart
  }, {
    title: 'Community Safety',
    description: 'Supporting policies and resources that keep our neighborhoods secure and peaceful.',
    icon: Shield
  }, {
    title: 'Economic Growth',
    description: 'Fostering a business-friendly environment that brings high-paying jobs to the West Valley.',
    icon: TrendingUp
  }, {
    title: 'Resident Advocacy',
    description: 'Giving a strong, unified voice to the taxpayers and families of Maricopa County.',
    icon: Users
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="issues" className="py-24 bg-white" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <div className="text-center mb-16" data-id="element-118">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-pac-navy mb-4" data-id="element-119">
            Issues We Fight For
          </h2>
          <div className="w-24 h-1 bg-pac-red mx-auto" data-id="element-120"></div>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-121">
          {issues.map((issue, index) => <motion.div key={index} variants={itemVariants} className="bg-slate-50 p-8 rounded-xl border border-slate-200 hover:border-pac-blue hover:shadow-xl transition-all group" data-id="element-122">
              <div className="w-14 h-14 bg-white rounded-lg shadow-sm flex items-center justify-center mb-6 group-hover:bg-pac-navy transition-colors" data-id="element-123">
                <issue.icon className="h-7 w-7 text-pac-blue group-hover:text-pac-gold transition-colors" data-id="element-124" />
              </div>
              <h3 className="font-serif text-2xl font-bold text-pac-navy mb-3" data-id="element-125">
                {issue.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-126">
                {issue.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}